import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useModal } from "context/ModalContext";
import { useLocation } from "react-router-dom";
import { setTestSuite } from "actions/App";
import Server from "components/Server/index";
import LanguageSwitcher from "components/LanguageSwitcher/indexNew";

const AuthTemplate = ({ children }) => {
  const location = useLocation();
  const { openModal, closeModal } = useModal();
  const theme = useSelector((state) => state.app.theme);
  const width = useSelector((state) => state.app.width);
  const showTestSuite = useSelector((state) => state.app.showTestSuite);
  const height = useSelector((state) => state.app.height);
  
  const [count, setCount] = useState(0);
  const timeoutRef = useRef(null);
  const [bottomMarginClass, setBottomMarginClass] = useState("");
  const [topMarginClass, setTopMarginClass] = useState("");
  
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    let password = location.pathname === "/setup/password";
    if (height > 900) {
      setTopMarginClass("mt-[10vh]");
      password ? setBottomMarginClass("mt-[18vh]") : setBottomMarginClass("mt-[30vh]");
    } else if (height > 850 && height <= 900) {
      setTopMarginClass("mt-[10vh]");
      password ? setBottomMarginClass("mt-[18vh]") : setBottomMarginClass("mt-[25vh]");
    } else if (height > 750 && height <= 850) {
      setTopMarginClass("mt-[5vh]");
      password ? setBottomMarginClass("mt-[18vh]") : setBottomMarginClass("mt-[20vh]");
    } else if (height > 650 && height <= 750) {
      password ? setTopMarginClass("mt-[3vh]") : setTopMarginClass("mt-[10vh]");
      password ? setBottomMarginClass("mt-[20vh]") : setBottomMarginClass("mt-[15vh]");
    } else if (height > 550 && height <= 650) {
      password ? setTopMarginClass("mt-[2vh]") : setTopMarginClass("mt-[10vh]");
      password ? setBottomMarginClass("mt-[22vh]") : setBottomMarginClass("mt-[10vh]");
    } else {
      password ? setTopMarginClass("mt-[2vh]") : setTopMarginClass("mt-[10vh]");
      password ? setBottomMarginClass("mt-[22vh]") : setBottomMarginClass("mt-[5vh]");
    }
  }, [height, location]);

  const switchURL = () => {
    // Clear any existing timer
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    const newCount = count + 1;
    if (newCount > 7) {
      openModal(
        <Server onClose={() => closeModal()} />
      )
      setCount(0); // reset immediately
    } else {
      setCount(newCount);
      timeoutRef.current = setTimeout(() => {
        setCount(0);
      }, 5000);
    }
  };

  const isOnLocalhost = () =>
    (location.hostname === "localhost" || location.hostname === "127.0.0.1");

  return (
    <div className={`min-w-screen grid ${width > 1023 ? "grid-cols-2" : "grid-cols-1"}`}>
      {/* Left side (only on large screens) */}
      {width > 1023 && (
        <div
          className="w-full h-screen bg-right bg-cover bg-no-repeat"
          style={{
            backgroundImage: "url('/assets/images/Components/Auth/loginImage.jpg')",
          }}
        />
      )}

      {/* Right side form area */}
      <div
        className="relative h-full flex flex-col items-center"
        style={{
          backgroundColor: "#fff",
        }}
      >
        <div className={`w-2/3 ${topMarginClass} flex justify-start`}>
          <div
            className="w-48 h-24 flex items-center"
            onClick={switchURL}
          >
            <img
              alt={theme?.title}
              src={theme?.logo}
              className="max-h-full max-w-full object-contain"
            />
          </div>
        </div>

        <div
          className={`w-2/3 ${topMarginClass}`}
        >
          {children}
        </div>
        <div className={`w-2/3 ${bottomMarginClass} flex justify-start items-center gap-4`}>
          <LanguageSwitcher />
          {isOnLocalhost() && (
            <p
              className="cursor-pointer tw-paragraph-reg hover:underline"
              onClick={() => dispatch(setTestSuite(!showTestSuite))}
            >
              {!showTestSuite ? "Show Testing Suite" : "Hide Testing Suite"}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthTemplate;